/**
 * Domain map between Manage Returns list tabs (Open / Closed / All) and the quick-filter status chips
 * available under each tab. Mirrors the server-side `CLOSED_TERMINAL_RMA_STATUS_FILTERS` set
 * (rms-api: src/modules/manage-returns/types/manage-returns.interface.ts) and Section 8 of
 * `rms-client/ai-docs/manage-returns-redesign.md` ("Visible Status Chips" per tab).
 *
 * Used by both the shared filters store (to reset an incompatible chip on tab switch and to keep
 * `status_group` + `status` in sync with the API contract) and the redesigned status chip bar
 * (`rma-list-quick-filters-tabs`) to hide chips that are not relevant to the active tab.
 */

import { IRmaListTab } from "../../../../services/api/rma-list-service";
import { RMA_QUICK_FILTERS } from "./rma-quick-filters";

const CLOSED_TAB_QUICK_FILTERS: ReadonlySet<RMA_QUICK_FILTERS> = new Set([
    RMA_QUICK_FILTERS.DONE,
    RMA_QUICK_FILTERS.REJECTED,
    RMA_QUICK_FILTERS.CANCELED,
]);

export function isQuickFilterAllowedOnTab(tab: IRmaListTab, quickFilter: RMA_QUICK_FILTERS): boolean {
    if (quickFilter === RMA_QUICK_FILTERS.ALL) {
        return true;
    }
    if (tab === IRmaListTab.STATUS_GROUP_ALL) {
        return true;
    }
    const isClosedStatusChip = CLOSED_TAB_QUICK_FILTERS.has(quickFilter);
    if (tab === IRmaListTab.STATUS_GROUP_CLOSED) {
        return isClosedStatusChip;
    }
    return !isClosedStatusChip;
}
